
export enum ConversationStatus {
    NotStarted = 1,
    Started = 2,
    Completed = 3,
    Deleted = 4,
    ToBeSigned = 5
}
